import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Supporting artist & creators at LA BARBERÍA💈WEB3")}
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          Our Web3 Community {" "}
          <a href="https://discord.gg/n8AeUcGgNV">
          {emoji("LA BARBERÍA💈WEB3 DISCORD")}
          </a>
        </p>
      </div>
    </Fade>
  );
}
